import React from "react";
import { Grid } from "semantic-ui-react";
import InputField from "../../../../commonComponents/formComponents/inputField";
import { useSelector } from "react-redux";
import DropDown from "../../../../commonComponents/formComponents/dropDown";
import DeleteIcon from "../../../../commonComponents/deleteIcon";
import CopyRepElement from "../../../../GB_App/formSections/itemsTab/copyRepElement";
import { useCurrentShipmentType } from "../../../../hooks";
import PopUpIcon from "../../../../commonComponents/formComponents/PopUpIcon";

const AdditionalInfoForm = ({item:{code,statement,id},deleteData,updateData,saveData,copyData}) => {

  const addtionInfoCodeList = useSelector((state) => state.DropDownValues.agsExpAddInfo);
  const {isDisabled} = useCurrentShipmentType()
  return (
    <Grid.Row>
      <Grid.Column width='1' style={{textAlign:'center'}}>
        <CopyRepElement
          title='ADDITIONAL_INFORMATION'
          request={{ code,statement }}
          callback={copyData}
          isFormDisabled={isDisabled}
        />
      </Grid.Column>
      <Grid.Column width="7" className="divFormFeild border-bottom b-rw-0">
        <DropDown
          id={`addInfoCode-${id}`}
          label="ADDITIONAL INFO CODE"
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={addtionInfoCodeList}
          clearable //invoice1_lineItem1_additionalInfo1_code
          value={code}
          displayType={false}
          onChange={(value) =>{
            let statement=""
            if(value?.trim()) // filter if value is present otherwise no need of filtering
               statement=addtionInfoCodeList.find(c=>c.value==value)?.type
            saveData({id,code:value,statement: statement || " "}) // clear statement if code is blank
            updateData(id,{code:value?.trim(),statement}) 
            }            
          }
  
        /> 
      </Grid.Column>
      <Grid.Column
        width="7"
        className="divFormFeild  border-bottom"
      >        
        <InputField
          isLabel={false}
          id={`addInfoStatement-${id}`}
          type="text"
          labelIcon={<PopUpIcon
            icon="info circle"
            popupText={
                "please select ADDITIONAL INFO CODE in order to edit ADDITIONAL INFO STATEMENT"
            }
          />}
          label="ADDITIONAL INFO STATEMENT"          
          value={statement}
          className="field-bg"
          clearInput={false}
          onChange={(value) =>updateData(id,{statement:value}) }
          onBlur={(value) =>saveData({id,statement:statement || " "}) }
          disabled={!code}
        />
      </Grid.Column>

      <Grid.Column width="1" className="icon-delete-add-info">
         <DeleteIcon id={`item-additionalInfo-delete-${id}`} onClick={() =>deleteData(id)} />  
      </Grid.Column>
    </Grid.Row>
  );
}
export default React.memo(AdditionalInfoForm) 
